import { FC, PropsWithChildren } from 'react';

import { Box } from '@mui/material';
import clsx from 'clsx';
import { useBreakpoints } from 'hooks';

import { ModalComponent } from 'components/_basic/ModalComponent/ModalComponent';

import styles from './AuthModalView.module.scss';

export interface IAuthModalViewProps extends PropsWithChildren {
  isModalOpened: boolean;
  onModalClose: VoidFunction;
}

export const AuthModalView: FC<IAuthModalViewProps> = ({ isModalOpened, onModalClose, children }) => {
  const { isMobile } = useBreakpoints();

  return (
    <ModalComponent open={isModalOpened} onClose={onModalClose} fullScreen={isMobile}>
      <Box className={clsx(styles['content'])}>{children}</Box>
    </ModalComponent>
  );
};
